export enum GRID_TYPE_ENUM {
  submissionsGrid = 'submissions-grid',
  studiesGrid = 'studies-grid',
  sitesGrid = 'sites-grid',
  peoplesGrid = 'people-grid',
  questionnaireGrid = 'questionnaire-grid',
  studyTeamGrid = 'studyTeamGrid',
  siteTeamGrid = 'siteTeamGrid',
  clientTeamGrid = 'clientTeamGrid',
  wcgTeamGrid = 'wcgTeamGrid',
  studySiteGrid = 'studySiteGrid',
  studyOutcomeDocuments = 'studyOutcomeDocuments',
  siteOutcomeDocuments = 'siteOutcomeDocuments',
  siteSubmissionDocuments = 'siteSubmissionDocuments',
  studySubmissionDocuments = 'studySubmissionDocuments',
  siteFacilities = 'siteFacilities',
  siteSubmissions = 'siteSubmissions',
  studySubmissions = 'studySubmissions',
  submissionDocuments = 'submissionDocuments',
  submissionOutcomeDocuments = 'submissionOutcomeDocuments',
  submissionSites = 'submissionSites',
  configureDocumentTypes = 'configureDocumentTypes',
  configureSubmissionTypes = 'configureSubmissionTypes',
  notificationPreference = 'notificationPreference',
}

export enum GRID_LABELS {
  saveView = 'Save View',
  save = 'Save',
  update = 'Update',
  updateView = 'Update View',
  editView = 'Edit View',
  editViewTableHeader = 'Edit Table Views',
  edit = 'Edit',
  saveChanges = 'Save Changes',
  updateExistingView = 'Update existing view',
  createNewView = 'Create new view',
  create = 'Create',
}
